<template>
    <div class="pageInfo">
        <el-form :inline="true" :model="form" ref="formData" v-loading="loading"
                 label-width="120px">
            <el-form-item label="所属部门">
                <el-input style="width:200px" v-model="form.departmentNameBill" readonly></el-input>
            </el-form-item>
            <el-form-item label="项目名称">
                <el-input style="width:200px" v-model="form.projectName" readonly></el-input>
            </el-form-item>
            <el-form-item label="业务员">
                <el-input style="width:200px" v-model="form.salesMan" readonly></el-input>
            </el-form-item>

            <el-form-item label="乙方单位">
                <el-input style="width:200px" v-model="form.customerName" readonly></el-input>
            </el-form-item>
            <el-form-item label="签订人">
                <el-input style="width:200px" v-model="form.contactName" readonly></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
                <el-input style="width:200px" v-model="form.contactTel" readonly></el-input>
            </el-form-item>

            <el-form-item label="合同名称">
                <el-input style="width:200px" v-model="form.contractName" readonly></el-input>
            </el-form-item>
            <el-form-item label="合同编号">
                <el-input style="width:200px" v-model="form.billNo" readonly></el-input>
            </el-form-item>
            <el-form-item label="合同类型">
                <el-input style="width:200px" v-model="form.contractType" readonly></el-input>
            </el-form-item>

            <el-form-item label="发票类型">
                <el-input style="width:200px" v-model="form.invoiceType" readonly></el-input>
            </el-form-item>
            <el-form-item label="计税方式">
                <el-input style="width:200px" v-model="form.taxType" readonly></el-input>
            </el-form-item>
            <el-form-item label="税率%">
                <el-input style="width:200px" v-model="form.taxRate" readonly></el-input>
            </el-form-item>

            <el-form-item label="合同签订金额">
                <el-input style="width:200px" v-model="form.taxTotal" readonly></el-input>
            </el-form-item>
            <el-form-item label="甲方单位">
                <el-input style="width:200px" v-model="form.departmentName" readonly></el-input>
            </el-form-item>
            <el-form-item label="签订人">
                <el-input style="width:200px" v-model="form.signedBy" readonly></el-input>
            </el-form-item>

            <el-form-item label="签订人联系方式">
                <el-input style="width:200px" v-model="form.signedTel" readonly></el-input>
            </el-form-item>
            <el-form-item label="签订日期">
                <el-input style="width:200px" v-model="form.billDate" readonly></el-input>
            </el-form-item>
            <el-form-item label="送货日期">
                <el-input style="width:200px" v-model="form.deliveryDate" readonly></el-input>
            </el-form-item>

            <el-form-item label="送货地址">
                <el-input style="width:200px" v-model="form.deliveryAddress" readonly></el-input>
            </el-form-item>
            <el-form-item label="质量要求">
                <el-input style="width:200px" v-model="form.signedTel" readonly></el-input>
            </el-form-item>
            <el-form-item label="付款条款">
                <el-input style="width:200px" v-model="form.billDate" readonly></el-input>
            </el-form-item>

            <el-form-item label="备注">
                <el-input style="width:200px" v-model="form.remark" readonly></el-input>
            </el-form-item>
        </el-form>

        <div style="padding-top: 20px">
            <el-table
                    ref="table"
                    :data="dataList"
                    height="400"
                    show-summary
                    style="width: 100%;"
                    highlight-current-row
                    row-key="id"
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    border>
                <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="typeName"
                        width="100"
                        label="物资类别">
                </el-table-column>
                <el-table-column
                        prop="proCode"
                        width="120"
                        label="物资编码">
                </el-table-column>
                <el-table-column
                        prop="proName"
                        width="150"
                        label="物资名称">
                </el-table-column>
                <el-table-column
                        prop="units"
                        width="100"
                        label="计量单位">
                </el-table-column>
                <el-table-column
                        prop="icon"
                        width="100"
                        label="规格型号">
                </el-table-column>
                <el-table-column
                        prop="num"
                        width="100"
                        label="数量">
                </el-table-column>
                <el-table-column
                        prop="taxPrice"
                        width="120"
                        label="含税单价">
                </el-table-column>
                <el-table-column
                        prop="taxTotal"
                        width="120"
                        label="含税小计">
                </el-table-column>
                <el-table-column
                        prop="costPrice"
                        width="100"
                        label="成本单价">
                </el-table-column>
                <el-table-column
                        prop="costTotal"
                        width="100"
                        label="成本小计">
                </el-table-column>
                <el-table-column
                        prop="profitTotal"
                        width="100"
                        label="利润">
                </el-table-column>
                <el-table-column
                        prop="taxRate"
                        width="100"
                        label="税率%">
                </el-table-column>
                <el-table-column
                        prop="tax"
                        width="100"
                        label="税额">
                </el-table-column>
                <el-table-column
                        prop="price"
                        width="100"
                        label="单价">
                </el-table-column>
                <el-table-column
                        prop="total"
                        width="100"
                        label="金额">
                </el-table-column>
                <el-table-column
                        prop="origin"
                        width="100"
                        label="产地">
                </el-table-column>
                <el-table-column
                        prop="color"
                        width="100"
                        label="颜色">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        label="备注">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InfoPage",
        props: ['formData', 'loading'],
        components: {},
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',

                dataList:[],
                pageInfo: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
            };
        },
        mounted() {
            this.getListData();
        },
        updated () {
            this.$nextTick(() => {
                this.$refs.table.doLayout()
            })
        },
        methods: {
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/salecontract/listProduct",
                    param: {
                        billId:this.form.billId,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.data;
                    this.pageInfo.total = data.data.count;
                }
                this.dataList.map(item=>{
                    item._edit = true
                })
                this.dialoading = false;
            },

            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
        }
    }
</script>


